import { IMedicalReceptionData } from './../pages/Telemedicine/types/medicalReception.d';
import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'modules';

export interface ITelemedicineSlice {
  medicalReceptionData: IMedicalReceptionData;
  step: number;
  isTeleMedicineService: boolean;
  telemedicineServiceIsLoading: boolean;
}

const initial: ITelemedicineSlice = {
  medicalReceptionData: {
    gender: null,
    hairlossType: null,
    isHairlossPillTaken: null,
    hairlossPillName: '',
    isHairlossSideEffect: '',
    possessiveDisease: '',
    hasAllergy: '',
    hasLossExperience: '',
    hasFamilyHairLossHistory: '',
    comment: '',
    isAgreePersonalInformation: 'NO',
    isAgreeSensitiveInformation: 'NO',
    identificationNumber: null,
    diagnosisMethod: null,
    name: null,
    phoneNumber: null,
    doctorId: null,
    doctorDiagnosisExpenseId: null,
    expense: null,
    isTodayPossible: null,
    imageIds: [],
  },
  step: 0,
  isTeleMedicineService: false,
  telemedicineServiceIsLoading: false,
};

const telemedicineSlice = createSlice({
  name: 'telemedicine',
  initialState: initial,
  reducers: {
    setMedicalReceptionData: (state, action) => {
      state.medicalReceptionData = action.payload;
    },
    setStep: (state, action) => {
      state.step = action.payload;
    },
    setTeleMedicineServiceStatus: (state, action) => {
      state.isTeleMedicineService = action.payload;
    },
    setTelemedicineServiceIsLoading: (state, action) => {
      state.telemedicineServiceIsLoading = action.payload;
    },
  },
});

// Action =====================
export const { setTeleMedicineServiceStatus } = telemedicineSlice.actions;
export const { setMedicalReceptionData } = telemedicineSlice.actions;
export const { setStep } = telemedicineSlice.actions;
export const { setTelemedicineServiceIsLoading } = telemedicineSlice.actions;

// Selector =====================
export const getMedicalReceptionData = (state: RootState) =>
  state.telemedicineSlice.medicalReceptionData;

export const getMedicalReceptionStep = (state: RootState) =>
  state.telemedicineSlice.step;

export const getTeleMedicineServiceStatus = (state: RootState) =>
  state.telemedicineSlice.isTeleMedicineService;

export const getTelemedicineServiceIsLoading = (state: RootState) =>
  state.telemedicineSlice.telemedicineServiceIsLoading;

// Reducer =====================
export default telemedicineSlice.reducer;
